import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'kktcInfoModalClosed';

export function useKKTCInfoModal(shouldShow: boolean) {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isClosed = localStorage.getItem(STORAGE_KEY);
    if (!isClosed && shouldShow) {
      setShowModal(true);
    }
  }, [shouldShow]);

  const handleClose = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setShowModal(false);
  }, []);

  return { showModal, handleClose };
}
